import { MBTI_TYPES, type Mbti } from '@tarot/shared';

/**
 * MBTI 선택 — **항상 선택 입력**. '설정 안 함'이 기본값이며 비워도 모든 기능이 그대로 동작한다.
 * 내 정보(회원 저장) · 방 입장 · 나 혼자 해석 직전에서 공용으로 사용.
 */
export function MbtiPicker({
  value,
  onChange,
  disabled,
}: {
  value: Mbti | null;
  onChange: (v: Mbti | null) => void;
  disabled?: boolean;
}) {
  const chip = (selected: boolean) =>
    `rounded-lg border py-1.5 text-xs font-semibold tracking-wide transition disabled:opacity-50 ${
      selected
        ? 'border-gold bg-gold text-night'
        : 'border-white/15 bg-night/60 text-moon-dim hover:border-gold/50 hover:text-moon'
    }`;

  return (
    <div className="flex flex-col gap-2">
      <div className="grid grid-cols-4 gap-1.5">
        {MBTI_TYPES.map((t) => (
          <button
            key={t}
            type="button"
            disabled={disabled}
            onClick={() => onChange(value === t ? null : t)}
            aria-pressed={value === t}
            className={chip(value === t)}
          >
            {t}
          </button>
        ))}
      </div>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(null)}
        className={`${chip(value === null)} px-3`}
      >
        설정 안 함
      </button>
    </div>
  );
}

/** 접이식 래퍼 — 흐름을 막지 않도록 기본은 접혀 있음 */
export function MbtiField({
  value,
  onChange,
  open,
  onToggle,
  hint = '알려주시면 말투와 조언 방식을 맞춰드려요',
  disabled,
}: {
  value: Mbti | null;
  onChange: (v: Mbti | null) => void;
  open: boolean;
  onToggle: () => void;
  hint?: string;
  disabled?: boolean;
}) {
  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-white/10 bg-white/5 p-3">
      <button
        type="button"
        onClick={onToggle}
        className="flex items-center justify-between gap-2 text-left"
      >
        <span className="flex min-w-0 flex-col">
          <span className="text-sm font-medium">
            MBTI <span className="text-xs font-normal text-moon-dim">(선택)</span>
          </span>
          <span className="truncate text-xs text-moon-dim/80">{hint}</span>
        </span>
        <span className="flex shrink-0 items-center gap-1.5">
          {value && (
            <span className="rounded-full border border-gold/40 bg-gold/10 px-2.5 py-1 text-xs font-semibold text-gold">
              {value}
            </span>
          )}
          <span className="text-xs text-moon-dim">{open ? '접기' : '선택'}</span>
        </span>
      </button>
      {open && <MbtiPicker value={value} onChange={onChange} disabled={disabled} />}
    </div>
  );
}
